import React, { Component } from 'react';
import {
  WithStyles,
  Typography,
  Grid,
  withStyles,
  LinearProgress,
} from '@material-ui/core';
import _ from 'lodash';
// import cx from 'classnames';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { connect } from "react-redux";
import { styles } from "./useStyles";
import DialogLarge from "../../common/DialogLarge";
import MyPATTabs from "../../../common/MyPATTabs";
import MyPATTab from "../../../common/MyPATTab";
import { bindActionCreators } from "redux";
import { YourTask, TestDetails, TrackRequestProcess } from "./CardDataTabs";
import contentRequestService from "../../services/contentRequestServices";
import { contentRequestStateAction } from "../../reducers/contentRequestStates";
import { handleDTopNavContent } from "../../helper/dtTopNavContent";
import { contentRequestAccordianActions } from "../../reducers/contentRequestAccordianState";
import { any } from 'prop-types';
import { showMsg } from '../../../course/actions/loaderAlert';
import {
  CloseOutlined as CloseIcon
} from '@material-ui/icons';
import RequestHistoryDrawer from '../../components/RequestHistoryDrawer';
import classNames from 'classnames';
import { Subject } from '../../types/ContentRequest';

enum FilterValues {
  status = 'status',
  published = 'PUBLISHED',
  contentType = 'contentType',
  question = 'question',
  MMCQ = 8,
}

let count = 0;

const preSelectedFilterContent: any = {
  contentMenu: 'all',
  goalsDriller: {},
  contentFilterData: [
    {
      filterValue: FilterValues.contentType,
      isSelected: true,
      disabled: false,
      filters: [
        {
          filterValue: FilterValues.question,
          isSelected: true,
          disabled: false,
          filters: [],
        },
      ],
    },
    {
      filterValue: FilterValues.status,
      isSelected: true,
      filters: [
        {
          filterValue: FilterValues.published,
          isSelected: true,
          filters: [],
        },
      ],
    },
  ],
};

interface CardDataProps extends WithStyles<typeof styles> {
  classes: any,
  activeTabState: number,
  match: any,
  setContentRequestState: Function,
  contentRequestStateData: any,
  history: any,
  setAccordianState: Function,
  progressBarForQuestion: any,
  progressBarForTest: any,
  setTestAccordian: Function,
  setIsComingFromTest: Function,
  isComingFromTest: boolean,
  isTabOpened: boolean,
  setType: Function,
  type: string
  showMsg: any,
  SuccessMsg: any,
  onFeedbackClose: boolean,
  setFeedbackClose: Function,
  accordianState: any,
  setIsTabOpened: Function,
  setRemoveUnresolvedFeedbackCount: Function;
  removeUnresolvedFeedbackCount: any;
  removeUnresolvedFeedbackCountForTest: number
}
interface CardDataState {
  loader: boolean;
  selectedQuestionCount: any;
  selectedTempQuestions: any;
  selectedTrackedQuestionIds: any;
  selectQuestionDialogData: {
    sectionId: string;
    subSectionId: string;
    quesCodeAllowed: number;
    noOfQuestions: number;
    replaceIndex: number;
    replaceIndexJ: number;
    content_Id: string;
    addedQuestions: any;
  },
  chooseLibraryKey: any,
  data: any,
  selectQuestionDialogOpen: boolean,
  selectVideoDialogOpen: boolean,
  filterSelectedQuestion: any,
  preSelectedFilterContent: any,
  dataQuesTest: any,
  overalldataQuesTest: any,
  countQuesTest: number,
  trackProgressData: any,
  SuccessMsg: any,
  eventName: string,
  showFeedbackAlert: boolean,
  activeType: string;
  showContentHistory: boolean;
  isJobDoneIsRequired: boolean;

}

class CardData extends Component<CardDataProps, CardDataState> {
  constructor(props: CardDataProps) {
    super(props);
    this.state = {
      loader: true,
      selectedQuestionCount: 0,
      selectedTempQuestions: [],
      selectedTrackedQuestionIds: {},
      selectQuestionDialogData: {
        sectionId: '',
        subSectionId: '',
        quesCodeAllowed: -1,
        noOfQuestions: 0,
        replaceIndex: -1,
        replaceIndexJ: -1,
        content_Id: '',
        addedQuestions: [],
      },
      chooseLibraryKey: '',
      data: [],
      selectQuestionDialogOpen: false,
      selectVideoDialogOpen: false,
      filterSelectedQuestion: [],
      preSelectedFilterContent: {},
      dataQuesTest: [],
      overalldataQuesTest: {},
      countQuesTest: 0,
      trackProgressData: [],
      SuccessMsg: any,
      eventName: 'My Task',
      showFeedbackAlert: true,
      activeType: 'Question',
      showContentHistory: false,
      isJobDoneIsRequired: false

    };
  }

  componentDidMount = () => {
    const {
      match: { params = {} } = {},
      setContentRequestState,
      setAccordianState,
      setType,
    } = this.props;
    const { contentRequestId = '', role = '' } = params;
    const { dataQuesTest } = this.state;
    contentRequestService.getOwnerTaskByRole(contentRequestId, role).then((result: any) => {
      setContentRequestState({ ...result });
      const { requestInfo: { type = '', details: { subjects = [] } = {} } = {} } = result;
      setType({ type })
      this.setState({
        loader: false,
      })
    });
    setAccordianState([]);

    if (this.props.onFeedbackClose) {
      this.props.setIsTabOpened({ booleanValue: false })
      this.props.setRemoveUnresolvedFeedbackCount({ removeUnresolvedFeedbackCount: {} })
    }
    if (!this.props.isComingFromTest && !this.props.onFeedbackClose) {
      this.props.setTestAccordian([
        {
          testContent: [],
        },
      ]);
    }
    this.props.setFeedbackClose({ booleanValue: false });
  };

  handleContentSelect = (selectedQuestions: any) => {
    const firstSelectedQuestion = selectedQuestions[0];
    if (selectedQuestions.length > 0) {
      this.setState({
        selectedQuestionCount: selectedQuestions.length,
      });
    } else {
      this.setState({
        selectedQuestionCount: 0,
      });
    }
    this.setState({ selectedTempQuestions: firstSelectedQuestion });
  };

  handleContentSelectAll = (selectedQuestions: any) => {
    this.handleTrackSelectedQuestionIds(selectedQuestions);
    this.setState({
      selectedTempQuestions: selectedQuestions,
      selectedQuestionCount: selectedQuestions.length,
    });
  };

  handleTrackSelectedQuestionIds(selectedQuestions: any) {
    const { selectedTrackedQuestionIds, selectQuestionDialogData } = this.state;
    const { quesCodeAllowed, subSectionId } = selectQuestionDialogData;
    selectedQuestions.forEach((question: any) => {
      const key = question.content_Id;
      if (!selectedTrackedQuestionIds.hasOwnProperty(key)) {
        selectedTrackedQuestionIds[key] = {
          quesCodeAllowed,
          subSectionId,
          content_Id: question.content_Id,
        };
      }
    });
    this.setState({ selectedTrackedQuestionIds });
  }

  handleFilterSelectedQuestion = (selectedTempQuestions: any) => {
    this.setState({
      filterSelectedQuestion: [...this.state.filterSelectedQuestion, selectedTempQuestions],
    });
  };

  handleCheckContentExist = (content_Id: string) => {
    const { selectedTrackedQuestionIds, selectQuestionDialogData } = this.state;
    const {
      subSectionId: selectedSubSectionId,
      content_Id: selectedContentId,
      addedQuestions,
      quesCodeAllowed: selectedQuestCode,
      replaceIndex,
    } = selectQuestionDialogData;
    const addedContent_Ids: any = new Set(addedQuestions.map((content: any) => content.content_Id));
    addedContent_Ids.delete(selectedContentId);
    const key = content_Id;
    let isContentExist = false;
    if (selectedTrackedQuestionIds.hasOwnProperty(key)) {
      const quesCodeAllowed = selectedTrackedQuestionIds[key].quesCodeAllowed;
      const subSectionId = selectedTrackedQuestionIds[key].subSectionId;
      if (replaceIndex !== -1) {
        if (content_Id !== selectedContentId && addedContent_Ids.has(content_Id)) {
          isContentExist = true;
        }
      } else {
        if (selectedQuestCode == quesCodeAllowed) {
          if (selectedSubSectionId !== subSectionId) {
            isContentExist = true;
          }
        }
      }
    }
    return isContentExist;
  };

  handleAddContentClick = () => {
    let { selectedTempQuestions, chooseLibraryKey, data } = this.state;
    this.handleFilterSelectedQuestion(selectedTempQuestions);
    // this.setState({
    //     data: data,
    //     selectQuestionDialogOpen: false,
    //     selectedTempQuestions: [],
    // });
    //this.props.clearContentListData();
  };

  handleChooseFromLibrary = () => {
    let goalsDriller: any = {};
    this.setState({
      selectedQuestionCount: 0,
    });
    let preSelectedFilterContent = {
      contentMenu: 'createdbyme',
      goalsDriller: {},
      contentFilterData: [
        {
          filterValue: FilterValues.contentType,
          isSelected: true,
          disabled: false,
          filters: [
            {
              filterValue: FilterValues.question,
              isSelected: true,
              disabled: false,
              filters: [],
            },
          ],
        },
        {
          filterValue: FilterValues.status,
          isSelected: true,
          filters: [
            {
              filterValue: 'PUBLISHED',
              isSelected: true,
              filters: [],
            },
          ],
        },
      ],
    };
    this.setState({
      preSelectedFilterContent,
      selectQuestionDialogOpen: true,
    });
  };

  handleBackToTestpaperClick = (evt: any) => {
    this.setState({
      selectQuestionDialogOpen: false,
      selectVideoDialogOpen: false,
    });
    //this.props.clearContentListData();
  };
  renderProgressBar = () => {
    const { classes, type, contentRequestStateData } = this.props;
    const { requestInfo: { details: { subjects = {} } = {} } = {} } = contentRequestStateData;
    let totalCountValue = 0;
    let countValue = 0;
    let filterArray: any = [];
    subjects &&
      subjects.length &&
      subjects.map((val: any) => {
        const { questions = [] } = val;
        questions.map((val: any) => {
          filterArray.push(val);
        });
      });
    if (type === 'question' || type === 'Question' || (type === 'test' && filterArray.length)) {
      const { progressBarForQuestion: { totalCount = 0, count = 0 } = {} } = this.props;
      totalCountValue = totalCount;
      countValue = count;
    } else {
      const { progressBarForTest: { totalCount = 0, count = 0 } = {} } = this.props;
      totalCountValue = totalCount;
      countValue = count;
    }
    let percentVal = (countValue / totalCountValue) * 100;
    percentVal = isNaN(percentVal) ? 0 : percentVal;
    const percentage: any =
      percentVal === 0 || percentVal === 100 ? percentVal : String(percentVal.toFixed(2));
    return (
      <span className={classes.linearProgressStyle}>
        Percentage: {`${percentage}%`}
        <LinearProgress variant='determinate' value={percentage} />
        &nbsp;({countValue}/{totalCountValue})
      </span>
    );
  };

  // onJobDone = (contentRequestId: string, type: string) => {
  //   try {
  //     contentRequestService.itemDoneRequest({
  //       "contentRequestId": contentRequestId,
  //       "role": "creator",
  //       "contentType": type
  //     });
  //   } catch (error) {
  //   }
  // };

  getJob = () => {

  }

  onJobDone = async (contentRequestId: string, type: string) => {
    const response = await contentRequestService.itemDoneRequest({
      contentRequestId: contentRequestId,
      role: 'creator',
      contentType: type,
    });
    if (response.statusCode !== 200) {
      this.props.showMsg(response.responseMessage, 'error');
    }
  };

  handleJobDone = (id: string, type: string) => {
    const { contentRequestStateData = {} } = this.props;
    const { requestInfo: { details: { subjects = {} } = {} } = {} } = contentRequestStateData;
    let filterArray: any = [];
    subjects &&
      subjects.length &&
      subjects.map((val: any) => {
        const { questions = [] } = val;
        questions.map((val: any) => {
          filterArray.push(val);
        });
      });
    let typeOfContent = '';
    if ((type === 'test' && filterArray.length) || type === 'question' || type === 'Question') {
      typeOfContent = 'question';
    } else {
      typeOfContent = 'test';
    }
    this.onJobDone(id, typeOfContent);
    setTimeout(() => {
      localStorage.setItem('overallData', '');
      window.location.reload(false)
    }, 150)
  }

  getEventKey = (eventName: string) => {
    this.setState({ eventName });
  };

  getUnResolvedCount(type: string) {
    const { contentRequestStateData = {} } = this.props;
    let count = 0;
    if (type === 'question') {

      _.get(contentRequestStateData, 'requestInfo.details.subjects', []).forEach((subject: any) => {
        _.get(subject, 'questions', []).forEach((question: any) => {
          count = count + _.get(question, 'contentRequestItemsId.totalUnresolvedFeedbackCount', 0);
        });
      });
    } else {
      count = _.get(contentRequestStateData, 'requestInfo.details.testDetails.contentRequestItemsId.totalUnresolvedFeedbackCount', 0)
    }
    return count;

  }
  setActiveTab(value: any) {
    this.setState({
      activeType: value
    })
  }
  getFooterCTA(detailType: string) {
    const { contentRequestStateData } = this.props;
    let data;
    let type = (detailType === 'question' || detailType === 'Question' || this.state.activeType === 'Question') ? 'question' : 'test';
    if (detailType === 'both' && this.state.activeType === 'Question') {
      type = 'question'
    }
    if (type === 'question') {
      data = !_.isEmpty(contentRequestStateData) && _.get(contentRequestStateData.requestInfo, 'details.subjects[0].questions[0].nextAuthor.type', '');
    } else {
      data = !_.isEmpty(contentRequestStateData) && _.get(contentRequestStateData.requestInfo, 'details.testDetails.nextAuthor.type', '');
    }

    if (!_.isEmpty(contentRequestStateData) && data !== '') {
      if (data === 'evaluator') {
        return 'Submit for Evaluation'
      } else if (data === 'languageEvaluator') {
        return 'Submit for Language Evaluation'
      } else if (data === 'moderator') {
        return 'Submit for Moderation'
      } else {
        return 'Submit for Publishing'
      }
    } else {
      return 'Submit for Evaluation'
    }

  }

  toggleShowContentHistory = () => {
    this.setState(prevState => {
      return {
        ...prevState,
        showContentHistory: !prevState.showContentHistory
      }
    })
  }
  handleDisableButtonForUnresolvedCount = (type: string, count: number) => {
    const { removeUnresolvedFeedbackCount, removeUnresolvedFeedbackCountForTest } = this.props;
    if (count) {
      if (type === 'Question') {
        let overAllCount = 0;
        Object.keys(removeUnresolvedFeedbackCount).forEach((ele: any)=>{
          overAllCount = removeUnresolvedFeedbackCount[ele];
        })
        return count - overAllCount
      } else {
        return count - removeUnresolvedFeedbackCountForTest
      }
    } else {
      return count;
    }
  }

  getRelevantSubjects = (): Subject[] => {
    const { contentRequestStateData } = this.props;
    if(_.isEmpty(contentRequestStateData)) {
      return [];
    }
    const subjects: Subject[] = _.get(contentRequestStateData, 'requestInfo.details.subjects', []);
    return subjects.filter(({ questions }) => questions && !_.isEmpty(questions));
  }



  render = () => {
    const { classes, activeTabState, contentRequestStateData = {}, history = {}, accordianState, match } = this.props;
    const { loader, countQuesTest, dataQuesTest, overalldataQuesTest, trackProgressData, showFeedbackAlert } = this.state;
    const { requestInfo: { orderNote = {}, orderNoteAttachments = [] } = {} } = contentRequestStateData;
    const { aclMetaData: { createdBy: { id = { firstName: '', lastName: '' }, email = {} } = {} } = {} } = contentRequestStateData;
    const { requestInfo: { details: { subjects = [] } = {} } = {}, title = '', requestId = '', _id } = contentRequestStateData;
    const { requestInfo: { type = "", totalCount = 0 } = {} } = contentRequestStateData;
    const { requestInfo: { details: { testDetails = {}, courseTypes = {} } = {} } = {} } = contentRequestStateData;
    const { assignor = {} } = testDetails;
    
    let detailType = type;
    let filterArray: any = [];
    let overAllStatusOfCreator = 0;
    let totalUnresolvedCount = 0;
    let overAllStatusofQuestion = false;
    let overAllStatusofTest = false;
    let checkUnresolvedCountForSubmitEvaluation = 0;

    subjects &&
      subjects.length &&
      subjects.map((val: any) => {
        const { questions = [] } = val;
        questions.map((val: any) => {
          filterArray.push(val);
        });
      });
    const len = filterArray;

    if (len.length && detailType === 'test' && Object.keys(assignor).length !== 0) {
      detailType = 'both';
    }

    let questionType: any = new Set();
    accordianState && accordianState.length && accordianState.map((val: any) => {
     // if (!questionType.includes(val)) {
          questionType.add(val.type);
     // }
    });
   questionType = [...questionType]
    const questionTypes = questionType.join(", ");
    let totalCountValueForProgressBar = 0;
    let countValueForProgressBar = 0;
    let isJobDoneIsRequired = false;
   
    if (this.props.type === 'question' || this.props.type === 'Question' || ((this.props.type === 'test' && filterArray.length))) {
      const { progressBarForQuestion: { totalCount = 0, count = 0 } = {} } = this.props;
      totalCountValueForProgressBar = totalCount;
      countValueForProgressBar = count;
    } else {
      const { progressBarForTest: { totalCount = 0, count = 0 } = {} } = this.props;
      totalCountValueForProgressBar = totalCount;
      countValueForProgressBar = count;
    }
   
    if ((this.props.type === 'test' && filterArray.length) || this.props.type === 'question' || this.props.type === 'Question') {
      filterArray && filterArray.length && filterArray.forEach((ele: any) => {
        const { contentRequestItemsId = null } = ele;
        if (contentRequestItemsId) {
          const { overallStatus = {}, totalUnresolvedFeedbackCount = 0 } = contentRequestItemsId;
          const isOverJobCompleted = overallStatus.creator.isJobCompleted;
          if (isOverJobCompleted) {
            overAllStatusOfCreator = overAllStatusOfCreator + 1;
          }
          totalUnresolvedCount = totalUnresolvedFeedbackCount + totalUnresolvedCount;
        }
      })
      isJobDoneIsRequired = overAllStatusOfCreator === filterArray.length
    } else {
      const { contentRequestItemsId = null } = testDetails;
      let isJobComp = false;
      if (contentRequestItemsId) {
        const { overallStatus = {} } = contentRequestItemsId;
        const isOverJobCompleted = overallStatus.creator.isJobCompleted;
        if (isOverJobCompleted) {
          overAllStatusOfCreator = overAllStatusOfCreator + 1;
        }
        isJobComp = isOverJobCompleted
      }
      // isJobDoneIsRequired = overAllStatusOfCreator === 1;
      isJobDoneIsRequired = isJobComp;
    }
    
    let unResolvedCountTotal = (detailType === 'question' || detailType === 'Question' || (this.props.type === 'test' && filterArray.length) || this.props.type === 'Question') ? this.getUnResolvedCount('question') : this.getUnResolvedCount('test');
    checkUnresolvedCountForSubmitEvaluation = (detailType === 'question' || detailType === 'Question' || (this.props.type === 'test' && filterArray.length) || this.props.type === 'Question') ?
      this.handleDisableButtonForUnresolvedCount('Question', unResolvedCountTotal) : this.handleDisableButtonForUnresolvedCount('Test', unResolvedCountTotal)
    let footerCTA;
    footerCTA = this.getFooterCTA(detailType);
    let previousOverAllDone = localStorage.getItem('overallData')
    isJobDoneIsRequired = previousOverAllDone ? (previousOverAllDone === 'true' ? true : false) : isJobDoneIsRequired;
    
    
    const relevantSubjects = this.getRelevantSubjects();

    return (
      <>
        {loader ? (
          '...loading'
        ) : (
            <>
              <div>
                <DialogLarge
                  isShowHeader={true}
                  isSaveHidden={true}
                  isEditHidden={true}
                  headerTitle={`${requestId} | ${title
                    }`}
                  isFooter={((!isJobDoneIsRequired && this.state.eventName == "My Task") || !(unResolvedCountTotal === 0) || !(previousOverAllDone === '' || previousOverAllDone === null))}
                  topNavValue={handleDTopNavContent(this.props, relevantSubjects)}
                  htmlElements={this.renderProgressBar()}
                  isleftSideElement={true}
                  isJobDoneRequired={(overAllStatusOfCreator === filterArray.length)}
                  onJobDone={() => this.handleJobDone(_id, this.props.type)}
                  isJobDoneDisabled={((totalCountValueForProgressBar === countValueForProgressBar) && (checkUnresolvedCountForSubmitEvaluation === 0)) ? false : true}
                  footerCTAName={footerCTA}
                >
                  <Grid container className={classes.tabContainer} alignItems="center">
                    <Grid item xs>
                      <MyPATTabs defaultSelected="My Task"
                        handleActiveTabChange={this.getEventKey}
                        activeTab={this.state.eventName}
                      >
                        <MyPATTab eventKey="My Task" isCustomCSS={true} >

                          <Grid
                            container
                            justify="flex-start"
                            className={classes.tabPanel}
                          >
                            {showFeedbackAlert && unResolvedCountTotal > 0 &&
                              <Grid container justify="flex-start" alignItems="center">
                                <Grid item xs={12}>
                                  <Typography className={classes.notificationBar}>
                                    <Grid>
                                      <span className="icon">
                                        <InfoOutlinedIcon />
                                      </span>
                                      <span>Feedback(s) received on your task(s), kindly view & resolve them.</span>
                                    </Grid>
                                    <Grid>
                                      <span className="closeIcon" onClick={() => {
                                        this.setState({
                                          showFeedbackAlert: false
                                        })
                                      }}>
                                        <CloseIcon />
                                      </span>
                                    </Grid>
                                  </Typography>
                                </Grid>
                              </Grid>
                            }
                            <YourTask overallDone={isJobDoneIsRequired} testDetails={testDetails} totalCount={totalCount} questionData={subjects} contentRequestId={_id} requestId={requestId} history={history} handleChooseFromLibrary={this.handleChooseFromLibrary} type={type}
                              setActiveTabInParent={this.setActiveTab.bind(this)}
                              totalUnresolvedCount={unResolvedCountTotal}
                              match = {this.props.match}
                            />
                          </Grid>
                        </MyPATTab>

                        <MyPATTab eventKey="Timeline" isCustomCSS={true}>
                          <Grid
                            container
                            justify="flex-start"
                            className={classes.tabPanel}
                          >
                            <TrackRequestProcess
                              overallDone={isJobDoneIsRequired}
                              type={type}
                              testDetails={testDetails}
                              questionData={filterArray}
                              data={dataQuesTest}
                              overallData={overalldataQuesTest}
                              totalCount={totalCountValueForProgressBar}
                              trackProgressData={filterArray}
                              match={match}
                            />
                          </Grid>
                        </MyPATTab>

                        <MyPATTab eventKey={"Order Notes"} isCustomCSS={true}>
                          <Grid className={classes.tabPanel}>
                            <TestDetails
                              firstName={id.firstName}
                              lastName={id.lastName}
                              orderNote={orderNote}
                              test={testDetails.type}
                              subject={relevantSubjects.map(subject => subject.name).join(', ')}
                              goal={courseTypes[0].name}
                              testName={testDetails.name}
                              type={detailType}
                              questionTypes={questionTypes}
                              orderNoteAttachments={orderNoteAttachments}
                            />
                          </Grid>
                        </MyPATTab>
                      </MyPATTabs>
                    </Grid>
                    <Grid item xs="auto" className={classNames(classes.clickable, classes.historyCTA)} onClick={this.toggleShowContentHistory}>
                      <Grid container alignItems="center">
                        <Grid item xs="auto">
                          <img src="/assets/svg/contentRequest/history-clock.svg" alt="history" />
                        </Grid>
                        <Grid item xs="auto">
                          History
                      </Grid>
                      </Grid >
                    </Grid>
                  </Grid>
                </DialogLarge>
              </div>
              <RequestHistoryDrawer key={_.get(contentRequestStateData, '_id', '')} contentRequest={contentRequestStateData} open={this.state.showContentHistory} onClose={this.toggleShowContentHistory} />
            </>
          )}
      </>
    );
  };
}

const mapStateToProps = (state: any) => ({
  activeTabState: _.get(state, 'contentRequestData.tabData.activeTab'),
  contentRequestStateData: _.get(state, 'contentRequestData.contentRequestData', {}),
  progressBarForQuestion: _.get(
    state,
    'contentRequestData.contentRequestAccordianData.progressBarForQuestion',
    {}
  ),
  progressBarForTest: _.get(
    state,
    'contentRequestData.contentRequestAccordianData.progressBarForTest',
    {}
  ),
  isComingFromTest: _.get(state, 'contentRequestData.contentRequestAccordianData.isComingFromTest'),
  isTabOpened: _.get(state, 'contentRequestData.contentRequestAccordianData.isTabOpened'),
  type: _.get(state, 'contentRequestData.contentRequestAccordianData.type', ''),
  onFeedbackClose: _.get(
    state,
    'contentRequestData.contentRequestAccordianData.onFeedbackClose',
    false
  ),
  accordianState: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianState', []),
  removeUnresolvedFeedbackCount: _.get(state, 'contentRequestData.contentRequestAccordianData.removeUnresolvedFeedbackCount', {}),
  removeUnresolvedFeedbackCountForTest: _.get(state, 'contentRequestData.contentRequestAccordianData.removeUnresolvedFeedbackCountForTest', 0)
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
  setContentRequestState: contentRequestStateAction.setContentRequestStates,
  setAccordianState: contentRequestAccordianActions.setAccordianState,
  setTestAccordian: contentRequestAccordianActions.setTestAccordian,
  setIsComingFromTest: contentRequestAccordianActions.setIsComingFromTest,
  setFeedbackClose: contentRequestAccordianActions.setFeedbackClose,
  setType: contentRequestAccordianActions.setType,
  setIsTabOpened: contentRequestAccordianActions.setIsTabOpened,
  setRemoveUnresolvedFeedbackCount: contentRequestAccordianActions.setRemoveUnresolvedFeedbackCount,
  showMsg: showMsg,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(CardData));
